// basic react component

import React, {useEffect, useState} from 'react';
import {MenuItemContainer} from '../../system/menu';
import {WebMidi} from 'webmidi';
import {ButtonV2} from '../../system/ButtonV2/ButtonV2';
import {HeartRateInteractor} from '../integrations/edit/integration/voicemod/HeartrateStatus';

export const MIDI = () => {
  const [midiEnabled, setMidiEnabled] = useState(false);
  const [midiOutputs, setMidiOutputs] = useState([]);
  const [intervalId, setIntervalId] = useState(null);
  const [emittedData, setEmittedData] = useState(null);
  const [midiOutputName, setMidiOutputName] = useState(null);
  const [waitingData, setWaitingData] = useState(false);
  const [heartRate, setHeartRate] = useState(0);

  useEffect(() => {
    WebMidi.enable()
      .then(() => setMidiEnabled(true))
      .catch((err) => alert(err));
  });

  return (
    <MenuItemContainer title={'Midi'}>
      <h1>MIDI</h1>
      <br></br>
      <p>
        {midiEnabled
          ? 'MIDI is enabled'
          : 'MIDI is not enabled. Please enable it in your browser settings.'}
      </p>
      <ButtonV2
        onClick={() => {
          setMidiOutputs(WebMidi.outputs);
        }}
      >
        List MIDI outputs
      </ButtonV2>
      <div>
        <ol>
          {midiOutputs.map((output) => (
            <li key={output.id}>
              {output.name}{' '}
              {intervalId == null && (
                <ButtonV2
                  type="secondary"
                  onClick={() => {
                    setMidiOutputName(output.name);
                    let counter = 0;
                    setIntervalId(
                      setInterval(() => {
                        counter = counter + 1;
                        let heartRate = (counter % 100) + 60;

                        setEmittedData(sendData(output.name, heartRate));
                      }, 1000)
                    );
                  }}
                >
                  Emitting Test Heart Rate Data
                </ButtonV2>
              )}
              {intervalId == null && (
                <ButtonV2
                  onClick={() => {
                    setMidiOutputName(output.name);
                  }}
                >
                  Emitting Heart Rate Data
                </ButtonV2>
              )}
              {intervalId != null && output.name === midiOutputName && (
                <ButtonV2
                  onClick={() => {
                    clearInterval(intervalId);
                    setIntervalId(null);
                    setMidiOutputName(null);
                    setEmittedData(null);
                  }}
                >
                  Stop Emitting Data
                </ButtonV2>
              )}
            </li>
          ))}
        </ol>
        {waitingData && <h1>Waiting for the heart rate data</h1>}
        {!waitingData && <h1>Heart Rate connected</h1>}
        <HeartRateInteractor
          onConnected={(heartRate) => {
            setWaitingData(false);
            setHeartRate(heartRate);
            if (midiOutputName) {
              setEmittedData(sendData(midiOutputName, heartRate));
            }
          }}
          onWaitingData={() => setWaitingData(true)}
        />
        <div style={{padding: '10px'}} />
        {emittedData && (
          <div>
            <h5>Heart Rate: {emittedData.heartRate}</h5>
            <h5> Data Sent to MIDI device</h5>
            <div>Output Name: {midiOutputName}</div>
            <div>Raw Attack: {emittedData.rawAttack}</div>
            <div>Note: {emittedData.note}</div>
            <h5>Calculation to get Heart Rate back from MIDI data</h5>
            <div>Heart Rate On Midi = Raw Attack * 10 + Note</div>
            <div>
              Heart Rate On Midi = {emittedData.rawAttack} * 10 +{' '}
              {emittedData.note}
            </div>
            <div>
              Heart Rate On Midi ={' '}
              {emittedData.rawAttack * 10 + emittedData.note}
            </div>
          </div>
        )}
      </div>
    </MenuItemContainer>
  );
};

const sendData = (midiOutputName, heartRate) => {
  let output = WebMidi.getOutputByName(midiOutputName);
  let channel = output.channels[1];
  let note = heartRate % 10;
  let rawAttack = Math.floor(heartRate / 10);
  channel.playNote(note, {
    rawAttack: rawAttack,
  });

  return {midiOutputName, heartRate, note, rawAttack};
};
